import BaseApi from './baseApi';
import IGoodsMovements from '../models/IGoodsMovements';
import moment from 'moment';
import IAuthentication from '../models/IAuthentication';
import { EMPTY_GUID } from '../../config/constants';
export default class GoodsMovementsApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Movements");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async CompleteMovement(idMovement: string) : Promise<boolean> {
        let json : string = this.getJsonCompleteMovement(idMovement);
        const response = await this.api.post('exec', json);
        return this.isSuccess(response);
    }

    async GetGoodsMovements(idCompany: string) : Promise<IGoodsMovements[]> {
        let json : string = this.getJsonReadWithIdCompany(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var goodMovements: IGoodsMovements[] = [];
            goodMovements = response.data as IGoodsMovements[];
            return goodMovements;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetGoodsMovementsCompleted(idCompany: string) : Promise<IGoodsMovements[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithOnlyCompleted(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var goodsMovements: IGoodsMovements[] = [];
            goodsMovements = response.data as IGoodsMovements[];
            return goodsMovements;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetGoodsMovementsDossier(idInbound: string) : Promise<IGoodsMovements[]> {
        let json : string = this.getJsonReadDossier(idInbound);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var goodMovements: IGoodsMovements[] = [];
            goodMovements = response.data as IGoodsMovements[];
            return goodMovements;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetGoodsMovementsForToday(idCompany: string) : Promise<IGoodsMovements[]> {
        let json : string = this.getJsonReadToday(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var goodMovements: IGoodsMovements[] = [];
            goodMovements = response.data as IGoodsMovements[];
            return goodMovements;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveGoodsMovements(goodMovements: IGoodsMovements) : Promise<string> {
        const json = this.getJsonSave(goodMovements);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateGoodsMovements(goodMovements: IGoodsMovements) : Promise<boolean> {
        const json = this.getJsonUpdate(goodMovements);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteGoodsMovements(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonCompleteMovement(idMovement: string): any {
        const json = {
            "spname": "dbo.create_movement",
            "parameters": [{
                "Item1": "IdMovement",
                "Item2": idMovement
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "GoodsMovements",
            "conditions": [{
                "Item1": "GoodsMovements",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(goodMovements: IGoodsMovements) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "code",
                "Item2": goodMovements.code
            }, {
                "Item1": "idCompanySourceWarehouse",
                "Item2": goodMovements.idCompanySourceWarehouse
            }, {
                "Item1": "idWarehouseSource",
                "Item2": goodMovements.idWarehouseSource
            }, {
                "Item1": "idCompanyDestinationWarehouse",
                "Item2": goodMovements.idCompanyDestinationWarehouse
            }, {
                "Item1": "idWarehouseDestination",
                "Item2": goodMovements.idWarehouseDestination
            }, {
                "Item1": "date",
                "Item2": goodMovements.date
            }, {
                "Item1": "description",
                "Item2": goodMovements.description
            }, {
                "Item1": "idCustomer",
                "Item2": goodMovements.idCustomer
            }, {
                "Item1": "idCompanySource",
                "Item2": goodMovements.idCompanySourceWarehouse
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "GoodsMovements"
        };
        return json;
    }

    private getJsonUpdate(goodMovements: IGoodsMovements) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "code",
                "Item2": goodMovements.code
            }, {
                "Item1": "idCompanySourceWarehouse",
                "Item2": goodMovements.idCompanySourceWarehouse
            }, {
                "Item1": "idWarehouseSource",
                "Item2": goodMovements.idWarehouseSource
            }, {
                "Item1": "idCompanyDestinationWarehouse",
                "Item2": goodMovements.idCompanyDestinationWarehouse
            }, {
                "Item1": "idWarehouseDestination",
                "Item2": goodMovements.idWarehouseDestination
            }, {
                "Item1": "date",
                "Item2": goodMovements.date
            }, {
                "Item1": "description",
                "Item2": goodMovements.description
            // }, {
            //    "Item1": "idStatus",
            //    "Item2": goodMovements.idStatus
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "GoodsMovements",
            "keyvalue": goodMovements.id
        };
        return json;
    }

    private getJsonReadWithIdCompany(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "GoodsMovements",
                "Item2": "id"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "code"
            }, {
                "Item1": "",
                "Item2": "(select id from Companies where id = idCompanySourceWarehouse) as idCompanySourceWarehouse"
            }, {
                "Item1": "",
                "Item2": "(select name from Companies where id = idCompanySourceWarehouse) as companySourceWarehouseName"
            }, {
                "Item1": "",
                "Item2": "(select id from Warehouses where id = idWarehouseSource) as idWarehouseSource"
            }, {
                "Item1": "",
                "Item2": "(select name from Warehouses where id = idWarehouseSource) as warehouseSourceName"
            }, {
                "Item1": "",
                "Item2": "(select id from Companies where id = idCompanyDestinationWarehouse) as idCompanyDestinationWarehouse"
            }, {
                "Item1": "",
                "Item2": "(select name from Companies where id = idCompanyDestinationWarehouse) as companyDestinationWarehouseName"
            }, {
                "Item1": "",
                "Item2": "(select id from Warehouses where id = idWarehouseDestination) as idWarehouseDestination"
            }, {
                "Item1": "",
                "Item2": "(select name from Warehouses where id = idWarehouseDestination) as warehouseDestinationName"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "date"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "description"
            // }, {
            //    "Item1": "GoodsMovements",
            //    "Item2": "idStatus"
            // }, {
            //    "Item1": "",
            //    "Item2": "(select Name from ListStatusGoodsMovements where id = IdStatus) as statusName"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "idCustomer"
            }],
            "tables": [{
                "Item1": "GoodsMovements"
            }],
            "conditions": [{
                "Item1": "GoodsMovements",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            // }, {
            //    "Item1": "GoodsMovements",
            //    "Item2": "idStatus",
            //    "Item3": "NOT IN",
            //    "Item4": "(SELECT ID FROM ListStatusGoodsMovements WHERE Name = 'Completed')",
            //    "Item5": "AND"
            }, {
                "Item1": "(GoodsMovements",
                "Item2": "idCompanySourceWarehouse",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "idCompanyDestinationWarehouse",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadWithOnlyCompleted(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "GoodsMovements",
                "Item2": "id"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "code"
            }, {
                "Item1": "",
                "Item2": "(select id from Companies where id = idCompanySourceWarehouse) as idCompanySourceWarehouse"
            }, {
                "Item1": "",
                "Item2": "(select name from Companies where id = idCompanySourceWarehouse) as companySourceWarehouseName"
            }, {
                "Item1": "",
                "Item2": "(select id from Warehouses where id = idWarehouseSource) as idWarehouseSource"
            }, {
                "Item1": "",
                "Item2": "(select name from Warehouses where id = idWarehouseSource) as warehouseSourceName"
            }, {
                "Item1": "",
                "Item2": "(select id from Companies where id = idCompanyDestinationWarehouse) as idCompanyDestinationWarehouse"
            }, {
                "Item1": "",
                "Item2": "(select name from Companies where id = idCompanyDestinationWarehouse) as companyDestinationWarehouseName"
            }, {
                "Item1": "",
                "Item2": "(select id from Warehouses where id = idWarehouseDestination) as idWarehouseDestination"
            }, {
                "Item1": "",
                "Item2": "(select name from Warehouses where id = idWarehouseDestination) as warehouseDestinationName"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "date"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "description"
            // }, {
            //    "Item1": "GoodsMovements",
            //    "Item2": "idStatus"
            // }, {
            //    "Item1": "",
            //    "Item2": "(select Name from ListStatusGoodsMovements where id = IdStatus) as statusName"
            }],
            "tables": [{
                "Item1": "GoodsMovements"
            }],
            "conditions": [{
                "Item1": "GoodsMovements",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            // }, {
            //    "Item1": "GoodsMovements",
            //    "Item2": "idStatus",
            //    "Item3": "IN",
            //    "Item4": "(SELECT ID FROM ListStatusGoodsMovements WHERE Name = 'Completed')",
            //    "Item5": "AND"
            }, {
                "Item1": "(GoodsMovements",
                "Item2": "idCompanySourceWarehouse",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "idCompanyDestinationWarehouse",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "GoodsMovements",
                "Item2": "id"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "code"
            }, {
                "Item1": "",
                "Item2": "(select id from Companies where id = idCompanySourceWarehouse) as idCompanySourceWarehouse"
            }, {
                "Item1": "",
                "Item2": "(select name from Companies where id = idCompanySourceWarehouse) as companySourceWarehouseName"
            }, {
                "Item1": "",
                "Item2": "(select id from Warehouses where id = idWarehouseSource) as idWarehouseSource"
            }, {
                "Item1": "",
                "Item2": "(select name from Warehouses where id = idWarehouseSource) as warehouseSourceName"
            }, {
                "Item1": "",
                "Item2": "(select id from Companies where id = idCompanyDestinationWarehouse) as idCompanyDestinationWarehouse"
            }, {
                "Item1": "",
                "Item2": "(select name from Companies where id = idCompanyDestinationWarehouse) as companyDestinationWarehouseName"
            }, {
                "Item1": "",
                "Item2": "(select id from Warehouses where id = idWarehouseDestination) as idWarehouseDestination"
            }, {
                "Item1": "",
                "Item2": "(select name from Warehouses where id = idWarehouseDestination) as warehouseDestinationName"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "date"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "description"
            // }, {
            //    "Item1": "GoodsMovements",
            //    "Item2": "idStatus"
            // }, {
            //    "Item1": "",
            //    "Item2": "(select Name from ListStatusGoodsMovements where id = IdStatus) as statusName"
            }],
            "tables": [{
                "Item1": "GoodsMovements"
            }],
            "conditions": [{
                "Item1": "GoodsMovements",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            //    "Item5": "AND"
            // }, {
            //    "Item1": "GoodsMovements",
            //    "Item2": "idStatus",
            //    "Item3": "NOT IN",
            //    "Item4": "(SELECT ID FROM ListStatusGoodsMovements WHERE Name = 'Completed')"
            }]
        };
        return json;
    }

    private getJsonReadDossier(idInbound: string) : any {
        const json = {
            "fields": [{
                "Item1": "GoodsMovements",
                "Item2": "id"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "code"
            }, {
                "Item1": "",
                "Item2": "(select id from Companies where id = idCompanySourceWarehouse) as idCompanySourceWarehouse"
            }, {
                "Item1": "",
                "Item2": "(select name from Companies where id = idCompanySourceWarehouse) as companySourceWarehouseName"
            }, {
                "Item1": "",
                "Item2": "(select id from Warehouses where id = idWarehouseSource) as idWarehouseSource"
            }, {
                "Item1": "",
                "Item2": "(select name from Warehouses where id = idWarehouseSource) as warehouseSourceName"
            }, {
                "Item1": "",
                "Item2": "(select id from Companies where id = idCompanyDestinationWarehouse) as idCompanyDestinationWarehouse"
            }, {
                "Item1": "",
                "Item2": "(select name from Companies where id = idCompanyDestinationWarehouse) as companyDestinationWarehouseName"
            }, {
                "Item1": "",
                "Item2": "(select id from Warehouses where id = idWarehouseDestination) as idWarehouseDestination"
            }, {
                "Item1": "",
                "Item2": "(select name from Warehouses where id = idWarehouseDestination) as warehouseDestinationName"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "date"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "description"
            }],
            "tables": [{
                "Item1": "GoodsMovements"
            }, {
                "Item1": "GoodsMovementsDetail"
            }, {
                "Item1": "StockDetail"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDeliveryNotes"
            }],
            "joins": [{
                "Item1": "GoodsMovements",
                "Item2": "Id",
                "Item3": "GoodsMovementsDetail",
                "Item4": "IdGoodsMovement"
            }, {
                "Item1": "GoodsMovementsDetail",
                "Item2": "IdPallet",
                "Item3": "StockDetail",
                "Item4": "IdPallet"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail ",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDeliveryNote  ",
                "Item3": "InboundsDeliveryNotes",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "InboundsDeliveryNotes",
                "Item2": "IdInbound",
                "Item3": "=",
                "Item4": idInbound,
                "Item5": "AND"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": 0
            }]
            //     "Item5": "AND"
            // }, {
            //     "Item1": "InboundsDeliveryNotesDetail",
            //     "Item2": "Deleted",
            //     "Item3": "=",
            //     "Item4": 0
            // }]
        };
        return json;
    }

    private getJsonReadToday(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "GoodsMovements",
                "Item2": "id"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "code"
            }, {
                "Item1": "",
                "Item2": "(select id from Companies where id = idCompanySourceWarehouse) as idCompanySourceWarehouse"
            }, {
                "Item1": "",
                "Item2": "(select name from Companies where id = idCompanySourceWarehouse) as companySourceWarehouseName"
            }, {
                "Item1": "",
                "Item2": "(select id from Warehouses where id = idWarehouseSource) as idWarehouseSource"
            }, {
                "Item1": "",
                "Item2": "(select name from Warehouses where id = idWarehouseSource) as warehouseSourceName"
            }, {
                "Item1": "",
                "Item2": "(select id from Companies where id = idCompanyDestinationWarehouse) as idCompanyDestinationWarehouse"
            }, {
                "Item1": "",
                "Item2": "(select name from Companies where id = idCompanyDestinationWarehouse) as companyDestinationWarehouseName"
            }, {
                "Item1": "",
                "Item2": "(select id from Warehouses where id = idWarehouseDestination) as idWarehouseDestination"
            }, {
                "Item1": "",
                "Item2": "(select name from Warehouses where id = idWarehouseDestination) as warehouseDestinationName"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "date"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "description"
            }],
            "tables": [{
                "Item1": "GoodsMovements"
            }],
            "conditions": [{
                "Item1": "GoodsMovements",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "date",
                "Item3": "=",
                "Item4": moment(new Date()).format('YYYY-MM-DD'),
                "Item5": "AND"
            }, {
                "Item1": "(GoodsMovements",
                "Item2": "idCompanySourceWarehouse",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "GoodsMovements",
                "Item2": "idCompanyDestinationWarehouse",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }
}
